import React from 'react'
import { Helmet } from 'react-helmet'
import useUrlPathBuilder from '../../hooks/useUrlPathBuilder'
import useBrand from '../../hooks/useBrand'

interface Props {
  slug: string
}

const AlternateHreflang: React.FC<Props> = ({ slug }) => {
  const brand = useBrand()
  const { urlPathBuilder } = useUrlPathBuilder()

  if (brand.alternateHreflang) {
    return (
      <Helmet>
        {brand.alternateHreflang.map((alternateHreflang, index) => {
          const alternateHref = urlPathBuilder([slug], {
            baseURL: alternateHreflang.baseUrl,
          })

          return (
            <link
              key={index}
              rel="alternate"
              href={alternateHref}
              hrefLang={alternateHreflang.hreflang}
            />
          )
        })}
      </Helmet>
    )
  }

  return null
}

export default AlternateHreflang
